// src/utils/eventBus.js
import mitt from 'mitt'

// Crear una instancia de mitt para usar como Event Bus
const eventBus = mitt()

export default eventBus